import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOMeta from "@/components/feature/SEOMeta";
import { homeData } from "@/mocks/home";
import { articles } from "@/mocks/articles";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const latestArticles = articles.slice(0, 4);

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "探花系列精品聚合平台",
    url: "http://lalahzz.cn/",
    potentialAction: {
      "@type": "SearchAction",
      target: "http://lalahzz.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "探花系列精品聚合平台",
    url: "http://lalahzz.cn/",
    logo: "http://lalahzz.cn/logo.png",
    description: "汇聚国内探花、探花精选、探花91等优质资源，打造探花爱好者必看的精品聚合平台。",
    sameAs: [],
  };

  const pageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "探花系列 | 国内探花在线精选 - 顶级探花大师直播聚合平台",
    description: "探花系列精品聚合平台，汇聚国内探花、探花精选、探花91等优质资源。",
    url: "http://lalahzz.cn/",
    isPartOf: {
      "@type": "WebSite",
      name: "探花系列精品聚合平台",
      url: "http://lalahzz.cn/",
    },
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "探花系列平台提供什么内容？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "探花系列精品聚合平台汇聚国内探花、探花精选、探花91、探花直播等优质资源，聚焦顶级探花大师与精品内容，为探花爱好者提供全面的内容聚合服务。",
        },
      },
      {
        "@type": "Question",
        name: "平台内容更新频率如何？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "平台每日更新200+精品资源，涵盖国内探花、探花精选、探花91等多个分类，确保用户能够第一时间获取最新内容。",
        },
      },
      {
        "@type": "Question",
        name: "如何联系探花系列平台？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过网站底部的联系方式或访问关于我们页面获取详细的联系信息。",
        },
      },
    ],
  };

  return (
    <>
      <SEOMeta
        title="探花系列 | 国内探花在线精选 - 顶级探花大师直播聚合平台"
        description="探花系列精品聚合平台，汇聚国内探花、探花精选、探花91等优质资源，聚焦顶级探花大师与探花直播，打造探花爱好者必看的聚合基地。"
        keywords="探花系列,国内探花,探花在线,探花91,探花精选,顶级探花,探花大师,探花直播,探花合集"
        canonical="http://lalahzz.cn/"
        ogType="website"
        jsonLd={[websiteJsonLd, orgJsonLd, pageJsonLd, faqJsonLd]}
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center">
          <div className="absolute inset-0">
            <img
              src={homeData.hero.backgroundImage}
              alt="探花系列精品聚合平台"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-28">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end lg:gap-12">
                <div className="lg:w-[60%]">
                  <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
                    探花系列
                    <br />
                    精品聚合平台
                  </h1>
                  <p className="mt-4 md:mt-6 text-base md:text-lg text-background-200 max-w-xl leading-relaxed">
                    {homeData.hero.subtitle}
                  </p>
                  <div className="mt-6 md:mt-8 flex flex-wrap gap-3">
                    <Link
                      to="/category/selection"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                    >
                      {homeData.hero.ctaText}
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                    </Link>
                    <Link
                      to="/about"
                      className="inline-flex items-center gap-2 px-6 py-3 border border-background-300/60 text-background-100 rounded-md font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
                    >
                      了解平台
                    </Link>
                  </div>
                </div>
                <div className="lg:w-[40%] mt-8 lg:mt-0">
                  <div className="flex flex-wrap gap-4">
                    {homeData.stats.map((stat) => (
                      <div
                        key={stat.label}
                        className="bg-background-50/10 backdrop-blur-sm rounded-lg px-4 py-3"
                      >
                        <div className="text-xl md:text-2xl font-bold text-primary-400">
                          {stat.value}
                        </div>
                        <div className="text-xs text-background-300 mt-0.5">
                          {stat.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-16 md:py-20 lg:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                  内容分类
                </h2>
                <p className="mt-2 text-sm md:text-base text-foreground-600">
                  六大精品分类，满足您的不同需求
                </p>
              </div>
              <Link
                to="/category/domestic"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看全部分类
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {homeData.categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-colors"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="text-lg font-bold text-background-50">
                          {cat.name}
                        </h3>
                        <p className="text-xs text-background-300 mt-1 line-clamp-1">
                          {cat.description}
                        </p>
                      </div>
                      <span className="text-xs font-medium text-primary-400 bg-background-950/40 px-2 py-1 rounded-full whitespace-nowrap">
                        {cat.count}部
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-16 md:py-20 lg:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                  精选推荐
                </h2>
                <p className="mt-2 text-sm md:text-base text-foreground-600">
                  编辑精选的优质内容，值得您关注
                </p>
              </div>
              <Link
                to="/category/selection"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看更多
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {homeData.featured.map((item) => (
                <article
                  key={item.id}
                  className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow"
                >
                  <Link to={`/article/${item.id}`} className="block">
                    <div className="aspect-[3/4] relative overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute top-3 right-3">
                        <span className="text-xs font-medium text-background-50 bg-accent-500 px-2.5 py-1 rounded-full">
                          {item.tag}
                        </span>
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <h3 className="text-sm font-bold text-background-50 line-clamp-2">
                          {item.title}
                        </h3>
                        <p className="text-xs text-background-300 mt-1 line-clamp-1">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-16 md:py-20 lg:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                  最新资讯
                </h2>
                <p className="mt-2 text-sm md:text-base text-foreground-600">
                  第一时间获取探花系列最新动态与行业资讯
                </p>
              </div>
              <Link
                to="/category/domestic"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                浏览全部资讯
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
              {latestArticles.map((article) => (
                <article
                  key={article.id}
                  className="group flex flex-col sm:flex-row gap-4 bg-background-100 rounded-xl overflow-hidden hover:bg-background-200 transition-colors p-4"
                >
                  <Link
                    to={`/article/${article.slug}`}
                    className="block sm:w-40 md:w-48 shrink-0"
                  >
                    <div className="aspect-video sm:aspect-square rounded-lg overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                  </Link>
                  <div className="flex flex-col justify-center min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-primary-700 bg-primary-100 px-2 py-0.5 rounded-full">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-foreground-500">
                        {article.date}
                      </span>
                    </div>
                    <Link to={`/article/${article.slug}`}>
                      <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                    </Link>
                    <p className="text-sm text-foreground-600 mt-1.5 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line w-3 h-3 flex items-center justify-center"></i>
                        {article.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                        {article.views}
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="text-center mb-10 md:mb-12">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                用户口碑
              </h2>
              <p className="mt-2 text-sm md:text-base text-foreground-600">
                来自真实用户的评价与反馈
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {homeData.testimonials.map((t) => (
                <div
                  key={t.id}
                  className="bg-background-50 rounded-xl p-6 md:p-8"
                >
                  <i className="ri-double-quotes-l w-8 h-8 flex items-center justify-center text-primary-400 text-2xl"></i>
                  <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                    {t.quote}
                  </p>
                  <div className="mt-6 pt-4 border-t border-background-200/70">
                    <p className="text-sm font-medium text-foreground-950">
                      {t.author}
                    </p>
                    <p className="text-xs text-foreground-500 mt-0.5">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-28 lg:py-32">
          <div className="absolute inset-0">
            <img
              src={homeData.cta.backgroundImage}
              alt="订阅探花系列资讯"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
                  {homeData.cta.title}
                </h2>
                <p className="mt-3 text-sm md:text-base text-background-300 max-w-md">
                  {homeData.cta.description}
                </p>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap shrink-0"
              >
                {homeData.cta.buttonText}
                <div className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center text-background-50"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
